import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

import printIcon from "../../../../Assests/printIcon.svg";
import viewIcon from "../../../../Assests/view.svg";

import ExportToExcel from "../../../../Componants/Common/ExportToExcel";
import HeaderNavigation from "../../../../Componants/Common/header Navigation/HeaderNavigation";
import CommonButton from "../../../../Componants/Common/Button";
import Subheader from "../../../../Componants/Common/Subheader";
import {
  fetchJobsheetSearchList,
  getStateList,
  getCityList,
  fetchCategoryList2,
  exportJobsheetSearchList,
} from "../../../../API Service/apiService";
import Paginate from "../../../../Componants/Common/Paginate";
import config from "../../../../Componants/Common/config";
import Loader from "../../../../Componants/Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import JobsheetView from "../../Repair/Dashboard/JobsheetView";
import { formatAnyDateToDisplay } from "../../../../utils/dateFormatter";
// import JobsheetPDF from "./JobsheetPDF";

const cells = [
  "Jobhseet Date",
  "Jobhseet No.",
  "Product Category",
  "Contact Person",
  "Jobhseet Type",
  "Service Type",
  "Jobhseet Status",
  "Action",
];
const options = [
  { label: "Option 1" },
  { label: "Option 2" },
  { label: "Option 3" },
];
const tableData = [
  {
    "Jobhseet Date": "2024-10-10",
    "Jobhseet No.": "JS-1001",
    "Product Category": "Electronics",
    "Contact Person": "John Doe",
    "Jobhseet Type": "Installation",
    "Service Type": "On-site",
    "Jobhseet Status": "Completed",
    Action: "View Details",
  },
  {
    "Jobhseet Date": "2024-10-12",
    "Jobhseet No.": "JS-1002",
    "Product Category": "Furniture",
    "Contact Person": "Alice Smith",
    "Jobhseet Type": "Repair",
    "Service Type": "In-store",
    "Jobhseet Status": "Pending",
    Action: "View Details",
  },
  {
    "Jobhseet Date": "2024-10-13",
    "Jobhseet No.": "JS-1003",
    "Product Category": "Appliances",
    "Contact Person": "Robert Brown",
    "Jobhseet Type": "Maintenance",
    "Service Type": "On-site",
    "Jobhseet Status": "In Progress",
    Action: "View Details",
  },
  {
    "Jobhseet Date": "2024-10-14",
    "Jobhseet No.": "JS-1004",
    "Product Category": "Electronics",
    "Contact Person": "Lucy Davis",
    "Jobhseet Type": "Installation",
    "Service Type": "In-store",
    "Jobhseet Status": "Cancelled",
    Action: "Reschedule",
  },
  {
    "Jobhseet Date": "2024-10-09",
    "Jobhseet No.": "JS-1005",
    "Product Category": "Furniture",
    "Contact Person": "Emma Wilson",
    "Jobhseet Type": "Repair",
    "Service Type": "On-site",
    "Jobhseet Status": "Completed",
    Action: "View Invoice",
  },
];

const jobsheetTypeList = [
  { title: "Repair" },
  { title: "Replacement" },
  { title: "AMC" },
];

const statusOptions = [
  { label: "Closed", value: "closed" },
  { label: "PendingForPart", value: "pendingForPart" },
  { label: "Unallocated", value: "unallocated" },
  { label: "Allocated", value: "allocated" },
  { label: "Reappointment", value: "reappointment" },
];

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 0,
  maxHeight: '90vh',
  overflowY: 'auto',
};

const JobsheetSearch = () => {
  const [checked, setChecked] = useState(false);
  const [jobsheetSearchList, setJobsheetSearchList] = useState([]);
  const [searchParams, setSearchParams] = useState({
    state: "",
    city: "",
    jobsheetType: "",
    serviceType: "",
    jobNumber: "",
    productCategory: "",
    status: "",
    page: 1,
    limit: 10,
  });

  // States for dropdowns
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = config.pageSize;
  const [totalRecords, setTotalRecords] = useState(0);
  const [dataSize, setDataSize] = useState(pageSize);

  // State for Modal
  const [jobOpen, setJobOpen] = useState(false);
  const [jobID, setJobID] = useState(null);
  const [isPrinting, setIsPrinting] = useState(false);


  const serviceTypeOptions = [
    { title: "On-site",id:1 },
    { title: "In-store",id:2 },
    { title: "Remote",id:3 },
  ];

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  // Fetch states
  const fetchStates = async () => {
    try {
      setLoading(true);
      const response = await getStateList("", 1, 10, "", "", true);
      setStates(response.data.states || []);
    } catch (error) {
      console.error("Error fetching states:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch cities based on selected state
  const fetchCities = async (stateId) => {
    if (!stateId) return;
    try {
      setLoading(true);
      const response = await getCityList("", "", stateId, 1, 10);
      setCities(response.data.cities || []);
    } catch (error) {
      console.error("Error fetching cities:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch categories
  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await fetchCategoryList2("");
      setCategories(response.data.categories || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    const updatedParams = { ...searchParams, page: newPage };
    setSearchParams(updatedParams);
    getJobsheetSearchList(updatedParams);
  };

  const getJobsheetSearchList = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await fetchJobsheetSearchList(params);
      if (response.status === "success") {
        setJobsheetSearchList(response.data.jobSheets);
        setTotalRecords(response.data.pagination.totalRecords);
      }else{
        setJobsheetSearchList([]);
        setTotalRecords(0)
        toast.error(response.message)
      }
    } catch (error) {
      console.error("Error fetching jobsheet search list:", error);
      setJobsheetSearchList([]);
      setTotalRecords(0)
      toast.error(error.response.data.message)
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    try {
      setLoading(true);
      setPage(1);
      const updatedParams = {
        ...searchParams,
        page: 1
      };
      setSearchParams(updatedParams);
      await getJobsheetSearchList(updatedParams);
    } catch (error) {
      console.error("Error in search:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    const resetParams = {
      state: "",
      city: "",
      jobsheetType: "",
      serviceType: "",
      jobNumber: "",
      productCategory: "",
      status: "",
      page: 1,
      limit: 10,
    };
    setSearchParams(resetParams);
    setSelectedState(null);
    setSelectedCity(null);
    setSelectedCategory(null);
    setSelectedStatus(null);
    getJobsheetSearchList(resetParams);
  };

  const handleExportToExcel = async () => {
    try {
      setLoading(true);
      const exportParams = {
        ...searchParams,
        page: -1,
        limit: -1,
      };
      const response = await exportJobsheetSearchList(exportParams);
      if (response?.status === "success" && response?.data?.filePath) {
        window.location.href = response.data.filePath;
        toast.success("File downloaded successfully");
      } else {
        throw new Error(response?.message || "Invalid response from server");
      }
    } catch (error) {
      console.error("Error exporting jobsheet list:", error);
      toast.error(error?.message || "Export failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      try {
        setLoading(true);
        await Promise.all([
          getJobsheetSearchList(),
          fetchStates(),
          fetchCategories()
        ]);
      } catch (error) {
        console.error("Error initializing data:", error);
      } finally {
        setLoading(false);
      }
    };
    
    initializeData();
  }, []);

  // Fetch data when page changes
  useEffect(() => {
    // Keep in sync if page is changed elsewhere
    setSearchParams((prev) => ({ ...prev, page }));
  }, [page]);

  // Fetch cities when state changes
  useEffect(() => {
    if (selectedState?._id) {
      fetchCities(selectedState._id);
    } else {
      setCities([]); // Clear cities when no state is selected
    }
  }, [selectedState]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  // Modal Handlers
  const handleJobViewModalOpen = (id) => {
    setJobID(id);
    setJobOpen(true);
  };

  const handleJobViewModalClose = () => {
    setJobOpen(false);
    setJobID(null); // Reset jobID when closing
  };

  // Handler specifically for the 'X' button, as requested
  const handleClose = () => {
    handleJobViewModalClose();
  };


  return (
    <Grid container>
      {(loading || isPrinting) && <Loader />}
      <Toaster/>
      <HeaderNavigation value={"Jobsheet Search"} />
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid container spacing={5}>
          {/* State Dropdown */}
          <Grid item>
            <Autocomplete
              id="state-autocomplete"
              options={states}
              getOptionLabel={(option) => option.stateName || ""}
              value={selectedState}
              onChange={(event, newValue) => {
                setSelectedState(newValue);
                setSelectedCity(null);
                setSearchParams((prev) => ({
                  ...prev,
                  state: newValue?._id || "",
                  city: "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="State"
                  variant="standard"
                  style={{ width: "12rem" }}
                />
              )}
            />
          </Grid>

          {/* City Dropdown */}
          <Grid item>
            <Autocomplete
              id="city-autocomplete"
              options={cities}
              getOptionLabel={(option) => option.cityName || ""}
              value={selectedCity}
              onChange={(event, newValue) => {
                setSelectedCity(newValue);
                setSearchParams((prev) => ({
                  ...prev,
                  city: newValue?._id || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="City"
                  variant="standard"
                  style={{ width: "12rem" }}
                />
              )}
            />
          </Grid>

          {/* Jobsheet Type Dropdown */}
          <Grid item>
            <Autocomplete
              id="jobsheet-type-autocomplete"
              options={jobsheetTypeList}
              getOptionLabel={(option) => option.title}
              onChange={(event, newValue) => {
                setSearchParams((prev) => ({
                  ...prev,
                  jobsheetType: newValue?.title || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Jobsheet Type"
                  variant="standard"
                  style={{ width: "12rem" }}
                />
              )}
            />
          </Grid>

          {/* Service Type Dropdown */}
          <Grid item>
            <Autocomplete
              id="service-type-autocomplete"
              options={serviceTypeOptions}
              getOptionLabel={(option) => option.title}
              onChange={(event, newValue) => {
                setSearchParams((prev) => ({
                  ...prev,
                  serviceType: newValue?.id || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Service Type"
                  variant="standard"
                  style={{ width: "12rem" }}
                />
              )}
            />
          </Grid>

          {/* Jobsheet Number TextField */}
          <Grid item>
            <TextField
              label="Jobsheet No."
              variant="standard"
              style={{ width: "12rem" }}
              value={searchParams.jobNumber}
              onChange={(e) => {
                setSearchParams((prev) => ({
                  ...prev,
                  jobNumber: e.target.value,
                }));
              }}
            />
          </Grid>

          {/* Product Category Dropdown */}
          <Grid item>
            <Autocomplete
              id="category-autocomplete"
              options={categories}
              getOptionLabel={(option) => option.categoryName || ""}
              value={selectedCategory}
              onChange={(event, newValue) => {
                setSelectedCategory(newValue);
                setSearchParams((prev) => ({
                  ...prev,
                  productCategory: newValue?._id || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Product Category"
                  variant="standard"
                  style={{ width: "12rem" }}
                />
              )}
            />
          </Grid>
          
          {/* Status Dropdown */}
          <Grid item>
            <Autocomplete
              id="status-autocomplete"
              options={statusOptions}
              getOptionLabel={(option) => option.label || ""}
              value={selectedStatus}
              onChange={(event, newValue) => {
                setSelectedStatus(newValue);
                setSearchParams((prev) => ({
                  ...prev,
                  status: newValue?.value || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Status"
                  variant="standard"
                  style={{ width: "12rem" }}
                />
              )}
            />
          </Grid>
        </Grid>

        <Grid container gap={2} spacing={5} sx={{ marginTop: "1rem" }}>
          <Grid item>
            <CommonButton
              name={"Search"}
              handleOnClick={handleSearch}
            />
          </Grid>
          <Grid item>
            <CommonButton name={"Reset"} handleOnClick={handleReset} />
          </Grid>
        </Grid>
      </Grid>

      {/* Jobsheet Search  list */}
      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <Grid item container>
          {/* <Typography variant="h6">Jobsheets</Typography> */}
          <Subheader heading={"Jobsheets"} />
        </Grid>
        <Grid item container justifyContent="flex-end">
          <ExportToExcel onClick={handleExportToExcel} />
        </Grid>

        <Grid container>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  {cells.map((cell, index) => (
                    <TableCell
                      key={index}
                      sx={{ color: "white", textAlign: "center" }}
                    >
                      {cell}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {jobsheetSearchList.length > 0 ? (
                  jobsheetSearchList.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell
                        align="center"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {/* <Checkbox checked={checked} onChange={handleChange} /> */}
                        {formatAnyDateToDisplay(row.jobsheetDate, "-")}
                      </TableCell>
                      <TableCell align="center">
                        {row.jobSheetNo || "N/A"}
                      </TableCell>
                      <TableCell align="center">
                        {row.productCategory || "N/A"}
                      </TableCell>
                      <TableCell align="center">
                        {row.contactPerson || "N/A"}
                      </TableCell>
                      <TableCell align="center">
                        {row.jobsheetType || "N/A"}
                      </TableCell>
                      <TableCell align="center">
                        {row.serviceType || "N/A"}
                      </TableCell>
                      <TableCell align="center">
                        {row.jobSheetStatus || "N/A"}
                      </TableCell>

                      <TableCell
                        align="right"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                        }}
                      >
                        <IconButton
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                          onClick={() =>{
                            setIsPrinting(false);
                            handleJobViewModalOpen(row._id)
                          }}
                        >
                          <img src={viewIcon} alt="active" />
                        </IconButton>

                        <IconButton
                          sx={{
                            outline: "none",
                            "&:focus": { outline: "none" },
                          }}
                          onClick={() =>{
                            setIsPrinting(true);
                            handleJobViewModalOpen(row._id)
                          }}
                        >
                          <img src={printIcon} alt="Print" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>

      {/* Pagination */}
      <Grid 
        container 
        sx={{ 
          marginTop: "1rem",
          marginBottom: "1rem",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: "0 10px"
        }}
      >
        <Paginate
          page={page}
          totalRecords={totalRecords}
          onPageChange={handlePageChange}
          dataSize={dataSize}
        />
      </Grid>
      
      <Modal
        open={jobOpen && !isPrinting}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleJobViewModalClose();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          {jobID && <JobsheetView jobID={jobID} onClose={handleClose} isPrinting={isPrinting} setJobID={setJobID} setIsPrinting={setIsPrinting} />}
        </Box>
      </Modal>
      {jobID && isPrinting && <JobsheetView jobID={jobID} onClose={handleClose} isPrinting={isPrinting} setJobID={setJobID} setIsPrinting={setIsPrinting} />}
    </Grid>
  );
};

export default JobsheetSearch;

